import { render, staticRenderFns } from "./RejectClueApply.vue?vue&type=template&id=84926fa0&scoped=true"
import script from "./RejectClueApply.vue?vue&type=script&lang=js"
export * from "./RejectClueApply.vue?vue&type=script&lang=js"
import style0 from "./RejectClueApply.vue?vue&type=style&index=0&id=84926fa0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84926fa0",
  null
  
)

export default component.exports